import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-326cd12c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "error__icon bx bx-error-circle" }, null, -1))
const _hoisted_2 = { class: "text-md text-weight-medium" }
const _hoisted_3 = { key: 0 }


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewLayoutError',
  props: {
    title: {},
    text: {},
    local: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["error", { layout: !_ctx.local }])
  }, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.text), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})